function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Arrow_-_Right_Square",
  "data-name": "Arrow - Right Square",
  d: "M14.08,20H5.91C2.375,20,0,17.725,0,14.34V5.67C0,2.279,2.375,0,5.91,0H14.08C17.621,0,20,2.279,20,5.67v8.67C20,17.725,17.621,20,14.08,20ZM5.92,9.25A.751.751,0,0,0,5.17,10a.742.742,0,0,0,.751.75h6.35L9.79,13.22a.763.763,0,0,0-.221.53.792.792,0,0,0,.221.53.755.755,0,0,0,1.06,0l3.769-3.75a.772.772,0,0,0,0-1.06L10.851,5.72a.753.753,0,0,0-1.06,0,.766.766,0,0,0,0,1.069L12.27,9.25Z"
});

function SvgArrowRightSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSquare);
export default __webpack_public_path__ + "static/media/arrow-right-square.8d96ab4d.svg";
export { ForwardRef as ReactComponent };